<template>
  <div class="hidden lg:ml-8 lg:flex lg:space-x-8">
    <template v-for="item in menu" :key="item.label">

      <!-- Menu item simple (avec href direct) -->
      <template v-if="item.href">
        <NuxtLink
            :to="item.href"
            :class="item.class"
            class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium truncate transition-all duration-200"
        >
          {{ t(item.label) }}
        </NuxtLink>

<!--        <button-->
<!--            v-else-->
<!--            @click="scrollToSection(item.href)"-->
<!--            :class="item.class"-->
<!--            class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium truncate bg-transparent hover:bg-transparent focus:outline-none transition-all duration-200"-->
<!--        >-->
<!--          {{ t(item.label) }}-->
<!--        </button>-->
      </template>

      <!-- Menu item avec dropdown (contient des items) -->
      <div v-else-if="item.items" class="relative group">
        <button
            class="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 text-sm font-medium truncate bg-transparent transition-all duration-200 focus:outline-none"
        >
          {{ t(item.label) }}
          <svg class="ml-1 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <!-- Dropdown menu -->
        <div class="absolute left-0 top-full mt-1 w-48 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
          <div class="py-1">
            <template v-for="subItem in item.items" :key="subItem.href || subItem.label">

              <!-- Sous-menu simple -->
              <template v-if="subItem.href">
                <NuxtLink
                    :to="subItem.href"
                    :class="subItem.class"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-150"
                >
                  {{ t(subItem.label) }}
                </NuxtLink>

<!--                <button-->
<!--                    v-else-->
<!--                    @click="scrollToSection(subItem.href)"-->
<!--                    :class="subItem.class"-->
<!--                    class="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-150 bg-transparent"-->
<!--                >-->
<!--                  {{ t(subItem.label) }}-->
<!--                </button>-->
              </template>

              <!-- Sous-menu avec sous-éléments (niveau 3) -->
              <div v-else-if="subItem.items" class="relative group/sub">
                <button class="w-full text-left flex items-center justify-between px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-150 bg-transparent">
                  {{ t(subItem.label) }}
                  <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                  </svg>
                </button>

                <!-- Sous-sous-menu -->
                <div class="absolute left-full top-0 w-48 bg-white rounded-md shadow-lg opacity-0 invisible group-hover/sub:opacity-100 group-hover/sub:visible transition-all duration-200 z-50">
                  <div class="py-1">
                    <template v-for="subSubItem in subItem.items" :key="subSubItem.href">
                      <NuxtLink
                          :to="subSubItem.href"
                          :class="subSubItem.class"
                          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-150"
                      >
                        {{ t(subSubItem.label) }}
                      </NuxtLink>

<!--                      <button-->
<!--                          v-else-if="subSubItem.href"-->
<!--                          :class="getAnchorClasses(item.href)"-->
<!--                          @click="subSubItem.class"-->
<!--                          class="w-full text-left block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-150 bg-transparent"-->
<!--                      >-->
<!--                        {{ t(subSubItem.label) }}-->
<!--                      </button>-->
                    </template>
                  </div>
                </div>
              </div>

            </template>
          </div>
        </div>
      </div>

    </template>
    <ManageButton v-if="isLoggedIn" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  isLoggedIn: Boolean,
  currentRoute: String
})

const { t, tm } = useI18n()
const activeSection = ref('')

const getLinkClasses = (href) => {
  // console.log('getLinkClasses', href)
  if (!href) return ''
  const isActive = props.currentRoute === href
  return isActive
      ? 'border-red-600 text-red-700 hover:border-red-700'
      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
}

const getAnchorClasses = (href) => {
  // console.log('getAnchorClasses', href)
  if (!href) return ''
  const sectionId = href.replace('/#', '')
  // console.log(sectionId)
  const isActive = activeSection.value === sectionId
  return isActive
      ? 'border-red-600 text-red-700 hover:border-red-700'
      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
}

const scrollToSection = (anchor) => {
  const targetId = anchor.replace('/#', '')
  const element = document.getElementById(targetId)

  if (element) {
    const navbarHeight = 80
    const elementPosition = element.offsetTop - navbarHeight

    window.scrollTo({
      top: elementPosition,
      behavior: 'smooth'
    })

    activeSection.value = targetId
  }
}

// Détection simple par scroll
const handleScroll = () => {
  const sections = ['services', 'realisation', 'about', 'testimonial', 'client', 'faq']
  const navbarHeight = 80
  const scrollTop = window.scrollY || document.documentElement.scrollTop

  let currentSection = ''
  let minDistance = Infinity

  sections.forEach(sectionId => {
    const element = document.getElementById(sectionId)
    if (element) {
      const distance = Math.abs(element.offsetTop - navbarHeight - scrollTop)
      if (distance < minDistance) {
        minDistance = distance
        currentSection = sectionId
      }
    }
  })

  if (currentSection !== activeSection.value) {
    activeSection.value = currentSection
  }
}

// Version throttlée du scroll pour les performances
let scrollTimeout = null
const throttledHandleScroll = () => {
  if (scrollTimeout) return

  scrollTimeout = setTimeout(() => {
    handleScroll()
    scrollTimeout = null
  }, 100)
}


// Fonction pour générer les services depuis les traductions
const getServicesFromTranslations = () => {
  try {
    // Accéder aux données de traduction des services
    const servicesData = tm('services.items')

    if (!servicesData || typeof servicesData !== 'object') {
      return []
    }

    // Convertir les clés en routes de services
    return Object.keys(servicesData).map(serviceKey => ({
      class: getLinkClasses(`/services/${serviceKey}`),
      href: `/services/${serviceKey}`,
      label: `services.items.${serviceKey}.title` // Pour la cohérence avec t()
    }))
  } catch (error) {
    console.warn('Erreur lors de la récupération des services:', error)
    return []
  }
}

// Structure de menu avec services dynamiques
const menu = computed(() => {
  const dynamicServices = getServicesFromTranslations()

  return [
    {
      label: 'nav.home',
      class:'',
      items: [
        { href: '/#services', label: 'nav.services', class: getAnchorClasses(`/#services`) },
        { href: '/#realisation', label: 'nav.realisation', class: getAnchorClasses(`/#realisation`) },
        { href: '/#about', label: 'nav.about', class: getAnchorClasses(`/#about`) },
        { href: '/#testimonial', label: 'nav.testimonial', class: getAnchorClasses(`/#testimonial`) },
        { href: '/#client', label: 'nav.customer', class: getAnchorClasses(`/#client`) },
        { href: '/#faq', label: 'nav.faq', class: getAnchorClasses(`/#faq`) },
      ]
    },
    {
      label: 'nav.company',
      class:'',
      items: [
        {
          label: 'nav.services',
          items: dynamicServices
        },
        { href: '/realisations', label: 'nav.realisation', class:getLinkClasses(`/realisations`) },
      ]
    },
    { href: '/contact', label: 'nav.contact', class:getLinkClasses(`/contact`) },
    { href: '/faq', label: 'nav.faq', class:getLinkClasses(`/faq`) }
  ]
})


onMounted(() => {
  window.addEventListener('scroll', throttledHandleScroll)
  handleScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', throttledHandleScroll)
  if (scrollTimeout) {
    clearTimeout(scrollTimeout)
  }
})
</script>

<style scoped>
/* Amélioration des transitions pour les dropdowns */
.group:hover .group-hover\:opacity-100 {
  transition-delay: 0ms;
}

.group:not(:hover) .group-hover\:opacity-100 {
  transition-delay: 150ms;
}

/* Support pour les sous-menus imbriqués */
.group\/sub:hover .group-hover\/sub\:opacity-100 {
  transition-delay: 0ms;
}

.group\/sub:not(:hover) .group-hover\/sub\:opacity-100 {
  transition-delay: 150ms;
}
</style>